<template>
  <div>
    <v-text-field
      v-bind="$attrs"
      v-on="$listeners"
      class="ma-0"
      label="Variable name"
      clearable
    ></v-text-field>
    <v-text-field
      v-bind="$attrs"
      v-on="$listeners"
      class="ma-0"
      label="Value"
      clearable
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: 'AppVariable',
  props: {
    value: {}
  }
};
</script>
